// DixaMessenger.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const DixaMessenger = () => {
  const [initialized, setInitialized] = useState(false);

  // Remove any existing Dixa script and clear the global _dixa_ object.
  const removeDixaScript = () => {
    const script = document.getElementById('dixa-script');
    if (script) {
      script.remove();
    }
    window._dixa_ = undefined;
  };

  // Set up a minimal _dixa_ global.
  const setUpDixaGlobal = () => {
    if (!window._dixa_) {
      window._dixa_ = {
        invoke: function (method, args) {
          this.pendingCalls = this.pendingCalls || [];
          this.pendingCalls.push([method, args]);
        },
        addListener: function (event, listener) {
          this.pendingAddListenerCalls = this.pendingAddListenerCalls || [];
          this.pendingAddListenerCalls.push([event, listener]);
        },
      };
    }
  };

  // Dynamically load the Dixa Messenger script with auto-init disabled.
  const loadDixaScript = () => {
    return new Promise((resolve, reject) => {
      if (document.getElementById('dixa-script')) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.id = 'dixa-script';
      script.type = 'text/javascript';
      script.async = true;
      // Disable auto-initialization:
      script.setAttribute('data-auto-init', 'false');
      script.src = 'https://messenger.dixa.io/bootstrap.js';
      script.onload = () => {
        resolve();
      };
      script.onerror = (err) => {
        reject(err);
      };
      document.body.appendChild(script);
    });
  };

  // Fetch a verified token from your backend.
  const fetchDixaToken = async () => {
    try {
      const access_token = Cookies.get('access_token');
      const url = `${process.env.REACT_APP_API_URL}/customers/generate-dixa-token?accessToken=${access_token}`;
      const response = await axios.get(url);
      if (response.data.token) {
        return response.data.token;
      } else {
        throw new Error('No token returned from endpoint');
      }
    } catch (error) {
      return null;
    }
  };

  // Initialize Dixa Messenger with the provided identity.
  const initDixa = async (identity) => {
    await loadDixaScript();
    setUpDixaGlobal();
    window._dixa_.invoke('init', {
      messengerToken: process.env.REACT_APP_DIXA_TOKEN, // Your Dixa Messenger token
      userIdentity: identity,
      verticalPadding: 75,
    });
    setInitialized(true);
  };

  useEffect(() => {
    if (!initialized) {
      const initMessenger = async () => {
        let identity = { type: 'anonymous' };
        const user = JSON.parse(localStorage.getItem('user'));

        if (user) {
          // If a user is stored, fetch the verified token.
          const token = await fetchDixaToken();
          if (token) {
            // Set identity using JWT instead of JWE.
            identity = { type: 'verified', payload: { type: 'jwe', token } };
          }
        }
        // Remove any previous instance before initialization.
        removeDixaScript();
        // Delay to ensure complete teardown before reinitializing.
        setTimeout(() => {
          initDixa(identity);
        }, 1000);
      };
      initMessenger();
    }
  }, [initialized]);

  return null; // This component does not render any UI elements.
};

export default DixaMessenger;
